import { securedAxiosInstance } from '@/backend/axios'
import Indicator from '@/lib/indicator'

const downloadCSV = (entryIds, isSeminar = false) => {
  const path = isSeminar ? '/seminar/download/entries/resume/csv' : '/entry/download/entries/resume/csv'
  Indicator.emitShow()
  securedAxiosInstance.post(path, [...entryIds]).then(response => {
    const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
    const blob = new Blob([bom, response.data], { type: 'text/csv' })
    _triggerDownload(blob, 'w_resume.csv')
  }).finally(() => {
    Indicator.emitHide()
  })
}

const downloadPDF = (entryIds) => {
  Indicator.emitShow()
  securedAxiosInstance.post('/entry/download/entries/resume/pdf', [...entryIds]).then((response) => {
    _triggerDownloadUrl(response.data)
  }).finally(() => {
    Indicator.emitHide()
  })
}

const downloadUrl = (url) => {
  _triggerDownloadUrl(url)
}

const downloadFile = (apiPath, fileName) => {
  Indicator.emitShow()
  securedAxiosInstance.get(apiPath, {
    responseType: 'blob'
  }).then(response => {
    const blob = new Blob([response.data], { type: response.headers.getContentType() })
    _triggerDownload(blob, fileName)
  }).catch(() => {
    // catch句を消すとコンソールに警告が出るから消さないでね！！
  }).finally(() => {
    Indicator.emitHide()
  })
}

function _triggerDownloadUrl (url) {
  const link = document.createElement('a')
  link.download = '' // S3のDLの場合、ファイル名を指定しても無視されるため省略
  link.href = url
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

function _triggerDownload (blob, fileName) {
  const link = document.createElement('a')
  link.download = fileName

  if (window.navigator.msSaveBlob) {
    // for IE
    window.navigator.msSaveBlob(blob, fileName)
  } else {
    link.href = window.URL.createObjectURL(blob)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}

export {
  downloadCSV,
  downloadPDF,
  downloadUrl,
  downloadFile
}
